import React, { Component } from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { ThemeProvider } from 'styled-components';
import * as T from './App.types';
import * as A from './actions';
import * as C from './constants';
import * as SL from './selectors';
import * as S from './App.styles';
import * as SGlobal from './App.global.styles';
import * as APlayer from 'modules/Player/actions';
import * as SLPlayer from 'modules/Player/selectors';
import { themes } from '../themes';
import Player from 'modules/Player/Player';

// const defaultShowId = '5c88b45a-f49f-11e8-a044-005056011137';

export class App extends Component<T.IAppProps> {
  isThemeInitialized = false;

  constructor(props: any) {
    super(props);
    const {
      dispatchSetTheme,
      dispatchSetCurrentlyPlayingTrackId,
      dispatchShowApiRequestInit,
      dispatchShowId,
      showId,
      currentlyPlayingTrackId,
      dispatchTrackApiRequestInit,
    } = this.props;

    const queryStringParams: any = queryString.parse(window.location.search);
    const showIdFromQuery = queryStringParams[C.SHOW_ID_ID_QUERY_STRING];
    const showIdInQueryIsDefined =
      typeof showIdFromQuery === 'string' && showIdFromQuery.length > 0;
    const trackIdFromQuery = queryStringParams[C.TRACK_ID_QUERY_STRING];
    const trackIdFromQueryIsDefined =
      typeof trackIdFromQuery === 'string' && trackIdFromQuery.length > 0;
    const themeFromQuery = queryStringParams[C.THEME_QUERY_STRING];

    if (!this.isThemeInitialized) {
      const theme = C.ALLOWED_THEMES.includes(themeFromQuery) ? themeFromQuery : C.DEFAULT_THEME;
      dispatchSetTheme({ theme });
      this.isThemeInitialized = true;
    }

    if (!showId && showIdInQueryIsDefined) {
      dispatchShowId({ showId: showIdFromQuery });

      dispatchShowApiRequestInit({
        id: showIdFromQuery,
      });
    }

    if (!currentlyPlayingTrackId && trackIdFromQueryIsDefined) {
      dispatchSetCurrentlyPlayingTrackId({ id: trackIdFromQuery });
      if (!showIdInQueryIsDefined) {
        dispatchTrackApiRequestInit({
          id: trackIdFromQuery,
          setShowIdFromResult: true,
        });
      }
    }
  }

  render() {
    const { theme } = this.props;

    return (
      <ThemeProvider key={theme} theme={themes[theme] || themes[C.DEFAULT_THEME]}>
        <S.App>
          <SGlobal.AppGlobalStyle key={theme} />
          <Player />
        </S.App>
      </ThemeProvider>
    );
  }
}

const mapDispatchToProps = {
  dispatchSetTheme: A.setTheme,
  dispatchSetCurrentlyPlayingTrackId: APlayer.setCurrentlyPlayingTrackId,
  dispatchTrackApiRequestInit: APlayer.trackApiRequestInit,
  dispatchShowApiRequestInit: APlayer.showApiRequestInit,
  dispatchShowId: APlayer.showId,
};

const mapStateToProps = (state: any) => ({
  theme: SL.getTheme(state),
  showId: SLPlayer.getShowId(state),
  currentlyPlayingTrackId: SLPlayer.getCurrentlyPlayingTrackId(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
